var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCouponCodeIconDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.998,
    height: 19.997,
    viewBox: "0 0 19.998 19.997",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "CouponCodeIcon",
    d: "M9,15l6-6m-5,.5A.5.5,0,1,1,9.5,9,.5.5,0,0,1,10,9.5Zm5,5a.5.5,0,1,1-.5-.5A.5.5,0,0,1,15,14.5ZM5,7.2A2.2,2.2,0,0,1,7.2,5h1a2.2,2.2,0,0,0,1.55-.64l.7-.7a2.2,2.2,0,0,1,3.12,0l.7.7A2.2,2.2,0,0,0,15.82,5h1a2.2,2.2,0,0,1,2.2,2.2v1a2.2,2.2,0,0,0,.64,1.55l.7.7a2.2,2.2,0,0,1,0,3.12l-.7.7a2.2,2.2,0,0,0-.64,1.55v1a2.2,2.2,0,0,1-2.2,2.2h-1a2.2,2.2,0,0,0-1.55.64l-.7.7a2.2,2.2,0,0,1-3.12,0l-.7-.7a2.2,2.2,0,0,0-1.55-.64h-1A2.2,2.2,0,0,1,5,16.82v-1a2.2,2.2,0,0,0-.64-1.55l-.7-.7a2.2,2.2,0,0,1,0-3.12l.7-.7A2.2,2.2,0,0,0,5,8.2Z",
    transform: "translate(-2.011 -2.011)",
    fill: "none",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCouponCodeIconDark);
export default __webpack_public_path__ + "static/media/CouponCodeIconDark.fd2d6006b18fe6c75a108cf426bffcf1.svg";
export { ForwardRef as ReactComponent };